module.exports = __webpack_public_path__ + "img/mergdata_hifi_4.95851f2d.png";